<div
  class="header-row"
  [class.header-row--right-plug]="overflows?.right"
  [class.header-row--left-plug]="overflows?.left"
  prlwResponsive
>
  <div
    *ngIf="overflows?.right && (xsmall$ | async) !== true"
    class="header-row-fade header-row-fade--right"
  ></div>
  <div
    *ngIf="overflows?.left && (xsmall$ | async) !== true"
    class="header-row-fade header-row-fade--left"
  ></div>

  <div
    *ngIf="(xsmall$ | async) === false"
    class="manage-overlay-toggle"
    [class.manage-overlay-toggle--overflow]="overflows?.right"
  >
    <prlw-icon
      name="three-dots"
      class="manage-overlay-toggle__icon"
      id="manage-overlay-toggle"
      data-cy="table-open-manage-overlay"
      (click)="handleOpenManage()"
    ></prlw-icon>
  </div>
</div>
